/**
 * 네이티브 → 웹 "결과 콜백" 키 (iOS·AOS·웹 공통 계약 — 이름 바꾸지 말 것).
 *
 * 네이티브 화면이 닫히거나 데이터가 바뀌면 앱이 window.__muyeonResult(key, payload) 를 부른다.
 * 웹은 이를 window CustomEvent(`muyeon:result:<KEY>`)로 뿌리고, 각 화면은
 * useResultRefresh([KEY...], reload) 로 구독해 서버에서 다시 읽는다.
 *  - 전역 슬롯(window.__onX) 하나를 여러 화면이 덮어쓰던 충돌을 없애려는 것 — 구독자는 여러 개여도 된다.
 *  - __muyeonResult 가 없는 옛 웹이면 앱은 예전 __onX 콜백으로 폴백한다(AppRouter 가 계속 받아준다).
 */
export const RESULT_KEYS = Object.freeze({
  QUOTES: "QUOTES",
  QUOTE_PREFS: "QUOTE_PREFS",
  AUTO_QUOTE: "AUTO_QUOTE",
  CHAT_ROOMS: "CHAT_ROOMS",
  CHAT_ROOM: "CHAT_ROOM",
  LESSONS: "LESSONS",
  LESSON_SCHEDULE: "LESSON_SCHEDULE",
  RESERVATIONS: "RESERVATIONS",
  RESUME: "RESUME",
  PROFILE: "PROFILE",
  JOB_POSTINGS: "JOB_POSTINGS",
  ACADEMY: "ACADEMY",
  SPACE: "SPACE",
  NOTIFICATIONS: "NOTIFICATIONS",
  NOTIFICATION_PREFS: "NOTIFICATION_PREFS",
  STUDIO_MEMBERS: "STUDIO_MEMBERS",
  REVIEWS: "REVIEWS",
  MEMBERSHIP: "MEMBERSHIP",
});

export const RESULT_EVENT_PREFIX = "muyeon:result:";

// 결과 이벤트 발행. 모르는 키는 무시(개발 중에만 경고) — 새 앱이 새 키를 보내도 옛 웹이 깨지지 않게.
export function emitResult(key, payload) {
  if (typeof window === "undefined") return;
  if (!Object.prototype.hasOwnProperty.call(RESULT_KEYS, key)) {
    if (process.env.NODE_ENV !== "production") console.warn("[muyeonResult] 알 수 없는 키:", key);
    return;
  }
  try {
    window.dispatchEvent(new CustomEvent(RESULT_EVENT_PREFIX + key, { detail: payload }));
  } catch (e) { /* noop */ }
}
